import { Pencil, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth-store';
import { useAdminOverlayStore } from '../../stores/admin-overlay-store';

export default function AdminOverlayToggle() {
  const location = useLocation();
  const { isAdmin, isAuthenticated } = useAuthStore();
  const { isOverlayEnabled, toggleOverlay } = useAdminOverlayStore();

  // Only show for authenticated admins
  if (!isAuthenticated || !isAdmin) {
    return null;
  }

  // Hide on admin backend pages (/admin/*)
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <button
      onClick={toggleOverlay}
      className={`
        fixed bottom-4 right-4 z-[9999]
        flex items-center gap-2 px-4 py-2.5 rounded-full
        font-medium text-sm shadow-lg
        transition-all duration-200 ease-in-out
        ${isOverlayEnabled
          ? 'bg-primary-600 text-white hover:bg-primary-700 ring-2 ring-primary-400 ring-offset-2'
          : 'bg-gray-800 text-gray-200 hover:bg-gray-700'
        }
      `}
      title={isOverlayEnabled ? 'Disable edit mode' : 'Enable edit mode'}
    >
      {isOverlayEnabled ? (
        <>
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
          </span>
          <span>Editing</span>
          <X className="w-4 h-4" />
        </>
      ) : (
        <>
          <Pencil className="w-4 h-4" />
          <span>Edit Mode</span>
        </>
      )}
    </button>
  );
}
